import dayjs from "dayjs";

export type Project = {
	ProjID: string,
	ScenarioProjID: string,
	ScenarioID: string,
	SourceID: string,
	ProjectName: string,
	State: string,
	LocationID: string,
	Source: string,
	Investment: number,
	RawProjectType: string,
	ProjectStage: string,
	StartDateConstruction: string,
	EndDateConstruction: string,
	PeriodStartYear: string,
	PeriodEndYear: string,
	FundingMode: string,
	km: number,
	MW: number,
	M2: number,
	EditedProject?: number,
	RemoveProjectFromModel?: number
	ReadonlyProject: number
	ProcessingPath?: number
	operateStatus?: string
};

export type UploadScenarioProject = {
	ProjID: string,
	SourceID: string,
	ProjectName: string,
	State: string,
	LocationID: string,
	Source: string,
	Investment: number,
	RawProjectType: string,
	ProjectStage: string,
	StartDateConstruction: string,
	EndDateConstruction: string,
	PeriodStartYear: string,
	PeriodEndYear: string,
	FundingMode: string,
	km: number,
	MW: number,
	M2: number,
	EditedProject?: number,
	RemoveProjectFromModel?: number,
	Forecast?: string,
	Ongoing?: string,
	ReadonlyProject?: number
	ProcessingPath?: number
	operateStatus?: string
	Errors?: string
};

export const newProject: Project = {
	ProjID: "",
	SourceID: "",
	ProjectName: "",
	State: "",
	LocationID: "",
	Source: "",
	Investment: 0,
	RawProjectType: "",
	ProjectStage: "",
	StartDateConstruction: dayjs().toISOString(),
	EndDateConstruction: dayjs().toISOString(),
	PeriodStartYear: "",
	PeriodEndYear: "",
	FundingMode: "",
	km: 0,
	MW: 0,
	M2: 0,
	// @ts-ignore
	ScenarioProjID: null,
	// @ts-ignore
	ScenarioID: null,
	EditedProject: 1,
	removedProject: 0,
	ProcessingPath: 1
};

export const samplePriorYearProject: PriorYearProject = {
	Source: "VIC",
	ProjectID: "12345",
	ProjectName: "Sample Project",
	State: "VIC",
	typeCast: "TypeA",
	Investment: 84000000,
	MW: 100,
	KM: 50,
	M2: 2000,
	ProjectStage: "StageA",
	DeliveryAgency: "Agency Name",
	ContractingModel: "Model Type",
	StartDateConstruction: "01/01/2023",
	EndDateConstruction: "01/01/2024",
	project_location: "Melbourne",
	Latitude: -37.8136,
	Longitude: 144.9631,
	FundingMode: "Public",
	sa4_code: "206",
	sa4_name: "Melbourne - Inner",
	CommonwealthFunding: 50000000,
	ProjectStatus: "Ongoing",
	PeriodStartYear: "01/01/2023",
	PeriodEndYear: "01/01/2024"
};

export type Assumption = {
	ProjectTypeID?: string,
	RawProjectType?: string,
	PlanningTimePercentage: number,
	ConstructionTimePercentage: number,
	CommissioningTimePercentage: number,
	PlanningCostPercentage: number,
	ConstructionCostPercentage: number,
	CommissioningCostPercentage: number,
}

export const baselineAssumption: Assumption = {
	RawProjectType: "Baseline",
	PlanningTimePercentage: 15,
	ConstructionTimePercentage: 80,
	CommissioningTimePercentage: 5,
	PlanningCostPercentage: 31,
	ConstructionCostPercentage: 59,
	CommissioningCostPercentage: 10
};

export const newAssumption: Assumption = {
	RawProjectType: "",
	PlanningTimePercentage: 0,
	ConstructionTimePercentage: 0,
	CommissioningTimePercentage: 0,
	PlanningCostPercentage: 0,
	ConstructionCostPercentage: 0,
	CommissioningCostPercentage: 0
};

export enum CreationMode {
	New = "new",
	Saved = "saved",
}

export type Scenario = {
	ScenarioID: string,
	ScenarioTitle: string,
	DateCreated: Date,
	ScenarioDescription?: string
};

export type RequestForm = {
	name: string,
	email: string,
	title: string,
	org: string,
	juri: string
};

export type PriorYearProject = {
	Source: string,
	ProjectID: string,
	ProjectName: string,
	State: string,
	typeCast: string,
	Investment: number,
	MW: number,
	KM: number,
	M2: number,
	ProjectStage: string,
	DeliveryAgency: string,
	ContractingModel: string,
	StartDateConstruction: string,
	EndDateConstruction: string,
	project_location: string,
	Latitude: number,
	Longitude: number,
	FundingMode: string,
	sa4_code: string,
	sa4_name: string,
	CommonwealthFunding: number,
	ProjectStatus: string,
	PeriodStartYear: string,
	PeriodEndYear: string
};

export type BatchProject = {
	Source: string,
	ProjectID: string,
	ProjectName: string,
	State: string,
	typeCast: string,
	Investment: string,
	MW: number,
	KM: number,
	M2: number,
	ProjectStage: string,
	DeliveryAgency: string,
	ContractingModel: string,
	StartDateConstruction: string,
	EndDateConstruction: string,
	project_location: string,
	Latitude: number,
	Longitude: number,
	FundingMode: string,
	sa4_code: string,
	sa4_name: string,
	CommonwealthFunding: string,
	ProjectStatus: string,
	PeriodStartYear: string,
	PeriodEndYear: string
};

export const newRequestForm = {
	name: "",
	email: "",
	title: "",
	org: "",
	juri: ""
};

export const fundingList = [
	{
		value: "Private",
		text: "Private",
	},
	{
		value: "Public",
		text: "Public",
	},
	{
		value: "Portfolio",
		text: "Portfolio",
	},
	{
		value: "Public/Private",
		text: "Public/Private",
	},
];

export const statusList = [
	{

		value: "Pre-construction",
		text: "Pre-construction",
	},
	{
		value: "Under construction",
		text: "Under construction",
	},
	{
		value: "Completed",
		text: "Completed",
	}
];

export const columnsNames = {
	SourceID: "Original Project ID",
	ScenarioID: "Scenario ID",
	ProjectName: "ProjectName",
	State: "State",
	Source: "Source",
	Investment: "Investment ($Million)",
	RawProjectType: "Project Type",
	ProjectStage: "Project Latest Status",
	StartDateConstruction: "Construction Start Date",
	EndDateConstruction: "Construction End Date",
	FundingMode: "Funding Mode",
	LocationID: "Location",
	MW: "MW",
	km: "KM",
	M2: "M2",
	PeriodStartYear: "Period Start Year",
	PeriodEndYear: "Period End Year",
	EditedProject: "Edited Project",
	RemoveProjectFromModel: "Removed Project",
	ScenarioProjID: "Scenario Project ID",
	ProjID: "Project ID",
	ProjectTypeID: "Project Type",
	TimePlanning: "Planning Time Allocation",
	TimeConstruction: "Construction Time Allocation",
	TimeCommissioning: "Commission Time Allocation",
	InvestmentPlanning: "Planning Investment Allocation",
	InvestmentConstruction: "Construction Investment Allocation",
	InvestmentCommissioning: "Commission Investment Allocation",
	ProcessingPath: "Processing Path",
	OperateStatus: "Operate Status",
	Forecast: "Forecast",
	Ongoing: "Ongoing",
	Errors: "Errors"
};

export const priorYearProjectColumnNames = {
	LastUploadedDate: "Last Uploaded Date",
	Source: "Source",
	ProjectID: "Project ID",
	ProjectName: "Project Name",
	Investment: "Investment ($)",
	State: "State",
	typeCast: "Project Type",
	MW: "MW",
	KM: "KM",
	M2: "M2",
	ProjectStage: "Project Stage",
	DeliveryAgency: "Delivery Agency",
	ContractingModel: "Contracting Model",
	StartDateConstruction: "Construction Start Date",
	EndDateConstruction: "Construction End Date",
	project_location: "Location",
	Latitude: "Latitude",
	Longitude: "Longitude",
	FundingMode: "Funding Mode",
	sa4_code: "SA4 Code",
	sa4_name: "SA4 Name",
	CommonwealthFunding: "Commonwealth Funding",
	ProjectStatus: "Project Status",
	PeriodStartYear: "Period Start Year",
	PeriodEndYear: "Period End Year"
};

export const priorYearProjectNote = ["Not all projects are included in the pipeline.",
	"Non-construction projects, projects missing information, or projects found duplicate in other sources might be removed.",
	"Please update existing projects, delete projects needs dropped, and add new projects into below list.",
	"PLEASE DO NOT CHANGE THE COLUMN ORDER, AND KEEP HEADER ON ROW 5."]

export const scenarioNote = ["Column R to T are for internal use only.",
	"Please use  the drop down list select project type and location and use dd/mm/yyyy format for dates.",
	"PLEASE DO NOT CHANGE THE COLUMN ORDER, AND KEEP HEADER ON ROW 4."]


export const energyProjectTypes = [
	"Coal",
	"Gas and Liquids",
	"Hydro",
	"Wind",
	"Utility Solar",
	"Pumped Hydro"
];

export const transmissionProjectTypes = [
	"Transmission (other)",
	"Transmission Line: Double Circuit",
	"Transmission Line: Single Circuit"
];

export const forecastDetachedHouseProjectTypes = [
	"Semi-detached Residential - Forecast",
	"Detached Residential - Forecast",
];

export const processingPathMap = {
	"1": (preProjectType, currentProjectType) => {
		if ([...energyProjectTypes, ...transmissionProjectTypes].indexOf(currentProjectType) === -1) {
			return [true, ""];
		} else {
			return [false, "Please select a non energy/transmission project type"];
		}
	},
	"2": (preProjectType, currentProjectType) => {
		if (energyProjectTypes.indexOf(currentProjectType) > -1) {
			return [true, ""];
		} else {
			return [false, "Please select an energy generation project type"];
		}
	},
	"3": (preProjectType, currentProjectType) => {
		if (energyProjectTypes.indexOf(currentProjectType) > -1) {
			return [true, ""];
		} else {
			return [false, "Please select an energy generation project type"];
		}
	},
	"4": (preProjectType, currentProjectType) => {
		if ([transmissionProjectTypes[1], transmissionProjectTypes[2]].indexOf(currentProjectType) === -1 && [transmissionProjectTypes[1], transmissionProjectTypes[2]].indexOf(preProjectType) !== -1) {
			return [false, "Please select a transmission line project type"];
		}

		if (forecastDetachedHouseProjectTypes.indexOf(preProjectType) !== -1 && forecastDetachedHouseProjectTypes.indexOf(currentProjectType) === -1)
			return [false, "Please select a residential project type"];

		return [true, ""];
	},
	"5": (preProjectType, currentProjectType) => {
		if (transmissionProjectTypes[0] === currentProjectType) {
			return [true, ""];
		} else {
			return [false, "Please select Transmission other as the project type"];
		}
	},
	"7": (preProjectType, currentProjectType) => {
		if ([...energyProjectTypes, ...transmissionProjectTypes].indexOf(currentProjectType) === -1) {
			return [true, ""];
		} else {
			return [false, "Please select an non energy/transmission project type"];
		}
	}
};

export const colorPelletList = [
	"#253746",
	"#7e2d40",
	"#73b469",
	"#e7b78a",
	"#c6264c",
	"#376d5f",
	"#ece81a",
	"#857874",
	"#ce6c45",
	"#8c4799",
	"#e2a78f",
	"#1f6899",
	"#abc7ca",
	"#8c7091",
	"#FFFF00",
	"#8c4799",
	"#edaf00",
	"#117a80",
	"#031e7f",
	"#c85f73",
	"#3a5a35",
	"#000000",
	"#edaf00",
	"#b2818c",
	"#87a79f",
	"#009245",
	"#EBD56E",
	"#376d5f",
	"#e25220",
	"#73b469",
	"#8c7091",
	"#8e0909",
	"#407e2d",
	"#2d407e",
	"#7e6b2d",
	"#700056",
	"#10c8ff",
	"#75B13B",
	"#4BA798",
	"#E54050",
	"#FDEF0A",
	"#62668F",
	"#C22932",
	"#F6A414",
	"#4B1279",
	"#9CA0AD",
	"#BAE356",
	"#88DDCD",
	"#CC47F4",
	"#6C9CE2",
	"#F8CB11",
	"#87A381",
	"#1C3847",
	"#fa6544",
	"#768584",
	"#E1BAB1",
	"#08D2B4",
	"#F79816",
	"#431E1E",
	"#B5B676",
	"#5E87F5",
	"#e7619e",
	"#97bd3d",
	"#ac3a4b",
	"#633149",
	"#cbe0e3",
	"#d71700",
	"#7d8098",
	"#c8af4a",
	"#504668",
	"#0eb676",
	"#70237f"
];

export const forecastProcessingPath = [3, 4, 5];
export const excelColumnMaxLength = 99999;
export const scenarioModelRunStatusMessage = "WAITING TO RUN";
export const scenarioResultMessage = "CALCULATING PIPELINE SIMULATION";
